var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import LoaderWhite from "./icons/LoaderWhite";
import { getAppThemeName } from "../../Services/appTheme";
const StyledButton = styled.button `
    transition: all ease-in-out 0.2s;
    position: relative;
    border-radius: 7px;
    font-family: ${(props) => props.theme.fontBase};
    font-weight: 600;
    font-size: 15px;
    transform: scale(1);
    overflow: hidden;
    text-align: ${(props) => {
    if (props.hasIconLeft) {
        return "right";
    }
    return "left";
}};
    color: ${color.body.base};
    ${(props) => {
    if (props.fullWidth) {
        return "width: 100%";
    }
}};
    padding: ${(props) => {
    if (props.hasIconLeft && props.transparent) {
        return "25px";
    }
    if (props.hasIconRight && props.transparent) {
        return "25px";
    }
    if (props.hasIconRight) {
        return "25px 100px 25px 25px";
    }
    if (props.hasIconLeft) {
        return "25px 25px 25px 100px";
    }
    return "25px";
}};
    background-color: ${(props) => {
    if (props.primary) {
        return props.theme.tertiary;
    }
    if (props.secondary) {
        return color.secondary.base;
    }
    if (props.quaternary) {
        return color.quaternary.base;
    }
    if (props.transparent) {
        return "transparent";
    }
    return props.theme.tertiary;
}};

    &:disabled {
        cursor: not-allowed;
    }

    &:hover,
    &:focus {
        ${(props) => {
    if (!props.transparent) {
        return "transform: scale(1.02);";
    }
}};
        ${(props) => {
    if (props.transparent) {
        return "color:" + color.base.base;
    }
}};
        background-color: ${(props) => {
    if (props.primary) {
        return props.theme.tertiaryHover;
    }
    if (props.secondary) {
        return color.secondary.hover;
    }
    if (props.quaternary) {
        return color.quaternary.hover;
    }
    if (props.transparent) {
        return "transparent";
    }
    return props.theme.tertiaryHover;
}};

        svg {
            ${(props) => {
    if (props.transparent) {
        return "fill:" + color.base.base;
    }
}};
        }
    }

    &:before {
        position: absolute;
        top: 0;
        height: 100%;
        width: 120px;
        background-image: url("/svg/button-shape-bg.svg");
        background-repeat: no-repeat;
        background-size: contain;
        ${(props) => {
    if (!props.transparent && props.hasIconLeft) {
        return "content: ''; transform: scaleX(-1); left: 0; background-position: top left;";
    }
    if (!props.transparent && props.hasIconRight) {
        return "content: ''; right: 0; background-position: top right;";
    }
}};

        ${(props) => props.appTheme === "invoned" &&
    css `
                display: none;
            `};
    }

    svg {
        transition: fill ease-in-out 0.2s;
        position: absolute;
        top: 27px;
        width: 15px;
        height: 15px;
        fill: ${color.body.base};
        ${(props) => {
    if (props.hasIconLeft && props.transparent) {
        return "left: 0;";
    }
    if (props.hasIconRight && props.transparent) {
        return "right: 0;";
    }
    if (props.hasIconLeft) {
        return "left: 25px;";
    }
    if (props.hasIconRight) {
        return "right: 25px;";
    }
}};
    }
`;
const StyledLoader = styled(LoaderWhite) `
    width: 30px !important;
    height: 30px !important;
    top: 17px !important;
`;
const Button = (_a) => {
    var { loading, hasIconLeft, hasIconRight, transparent, fullWidth, children, buttonIcon } = _a, props = __rest(_a, ["loading", "hasIconLeft", "hasIconRight", "transparent", "fullWidth", "children", "buttonIcon"]);
    return (React.createElement(StyledButton, Object.assign({ hasIconLeft: hasIconLeft, hasIconRight: hasIconRight, transparent: transparent, buttonIcon: buttonIcon, fullWidth: fullWidth, appTheme: getAppThemeName() }, props),
        loading ? React.createElement(StyledLoader, null) : React.createElement(React.Fragment, null, buttonIcon),
        children));
};
export default Button;
